import apiClient from './api.client';

const UserService = {
  getById: async (id) => {
    const res = await apiClient.get(`/user/${id}`);
    return res.data;
  },

  list: async (accountId) => {
    const res = await apiClient.get('/user', {
      params: accountId ? { accountId } : undefined,
    });
    return res.data;
  },

  create: async (payload) => {
    const res = await apiClient.post('/user', payload);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await apiClient.patch(`/user/${id}`, payload);
    return res.data;
  },

  remove: async (id) => {
    const res = await apiClient.delete(`/user/${id}`);
    return res.data;
  },
};

export default UserService;
